import Info from './index'

export default Info